var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_12757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2424 0H2.53396C1.30245 0 0.306641 0.938716 0.306641 2.09931V27.0236C0.306641 28.1842 1.30245 29.1286 2.53396 29.1286H28.2424C29.4739 29.1286 30.4756 28.1842 30.4756 27.0293V2.09931C30.4756 0.938716 29.4739 0 28.2424 0ZM9.25716 24.8219H4.77895V10.9176H9.25716V24.8219ZM7.01806 9.02305C5.58032 9.02305 4.41952 7.90228 4.41952 6.51981C4.41952 5.13734 5.58032 4.01657 7.01806 4.01657C8.4499 4.01657 9.6107 5.13734 9.6107 6.51981C9.6107 7.89659 8.4499 9.02305 7.01806 9.02305ZM26.0151 24.8219H21.5428V18.0632C21.5428 16.4531 21.5133 14.3766 19.2153 14.3766C16.8878 14.3766 16.5342 16.1345 16.5342 17.9494V24.8219H12.0678V10.9176H16.3575V12.8177H16.4164C17.0115 11.7254 18.4728 10.5705 20.6471 10.5705C25.1784 10.5705 26.0151 13.4492 26.0151 17.1927V24.8219V24.8219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_12757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.169,
    height: 29.1287,
    fill: "white",
    transform: "translate(0.306641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a04c53c945baf4cc0dc4c24e106f5ce5.svg";
export { ForwardRef as ReactComponent };